import { COLORS } from '../styles/tokens';

const BOOKING_URL = 'https://savvycal.com/terriwada/ai-readiness-assessment-advising';

export const ROUTE_META = {
  training: {
    label: 'AI Training',
    color: COLORS.slateBlue,
    icon: 'school',
    headline: 'Start with understanding.',
    subhead: "Your team's first job is to see what these tools can actually do.",
    bookingUrl: BOOKING_URL,
  },
  audit: {
    label: 'AI Audit & Consulting',
    color: COLORS.holidayBlue,
    icon: 'search',
    headline: 'Find the right thing to build first.',
    subhead: 'You feel the pain. The audit turns it into a ranked plan.',
    bookingUrl: BOOKING_URL,
  },
  build: {
    label: 'AI Execution & Build',
    color: '#6B91FF',
    icon: 'build',
    headline: 'You know what you want. Let\'s build it.',
    subhead: 'A scoped, fixed-fee engagement that ships.',
    bookingUrl: BOOKING_URL,
  },
  discovery: {
    label: 'Discovery Conversation',
    color: COLORS.slateBlue,
    icon: 'chat',
    headline: 'The right next step is a real conversation.',
    subhead: 'No decks. No proposal. Just honest context.',
    bookingUrl: BOOKING_URL,
  },
  nurture: {
    label: 'Stay Connected',
    color: COLORS.medGray,
    icon: 'mail',
    headline: 'Not the moment — and that\'s okay.',
    subhead: 'Here\'s what\'s worth doing while you wait.',
    bookingUrl: 'https://collaboxd.substack.com',
  },
};
